import React from "react";
import { useNavigate } from "react-router-dom";
import { API_BASE_URL } from "../apiConfig";

const Logout = () => {
  const navigate = useNavigate();

  const handleLogout = async () => {
    const idToken = localStorage.getItem("idToken");

    try {
      const response = await fetch(`${API_BASE_URL}/auth/logout`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${idToken}`,
        },
      });

      const data = await response.json();
      if (data.success) {
        localStorage.removeItem("idToken");
        alert("Logged out successfully!");
        navigate("/");
      } else {
        alert(data.message);
      }
    } catch (err) {
      alert("An error occurred during logout.");
    }
  };

  return (
    <div>
      <h2>Logout</h2>
      <button onClick={handleLogout}>Logout</button>
    </div>
  );
};

export default Logout;